export const CountryCodes = new Map([
  ["ao", "ago"],
  ["ao", "ago"],
  ["bj", "ben"],
  ["bw", "bwa"],
  ["bf", "bfa"],
  ["bi", "bdi"],
  ["cm", "cmr"],
  ["cv", "cpv"],
  ["cf", "caf"],
  ["td", "tcd"],
  ["km", "com"],
  ["dj", "dji"],
  ["cd", "cod"],
  ["gg", "gnq"],
  ["er", "eri"],
  ["et", "eth"],
  ["ga", "gab"],
  ["gm", "gmb"],
  ["gh", "gha"],
  ["gw", "gnb"],
  ["gn", "gin"],
  ["ci", "civ"],
  ["ke", "ken"],
  ["lr", "lbr"],
  ["mg", "mdg"],
  ["mw", "mwi"],
  ["ml", "mli"],
  ["mr", "mrt"],
  ["mu", "mus"],
  ["mz", "moz"],
  ["mz", "moz"],
  ["na", "nam"],
  ["ne", "ner"],
  ["ng", "nga"],
  ["cg", "cog"],
  ["rw", "rwa"],
  ["st", "stp"],
  ["sn", "sen"],
  ["sc", "syc"],
  ["sl", "sle"],
  ["so", "som"],
  ["za", "zaf"],
  ["ss", "ssd"],
  ["sd", "sdn"],
  ["sz", "swz"],
  ["tz", "tza"],
  ["tg", "tgo"],
  ["ug", "uga"],
  ["zm", "zmb"],
  ["zw", "zwe"]
]);

const defaultThreeCharacterCountryCode = "zaf";

export const convertTwoCharacterCountryCodeToThree = (code: string) => {
  return CountryCodes.get(code) ?? defaultThreeCharacterCountryCode;
}